<template>
    <div class="container-fluid">

        <div class="page-heading mb-4">
            <p class="page-eyebrow">EVENT MANAGEMENT</p>
            <h1 class="h3 mb-1 text-gray-800">Create event</h1>
            <p class="mb-0 text-muted">Add the event information delegates and administrators need.</p>
        </div>

        <EventForm :is-new="true"></EventForm>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import EventForm from "@/components/event/EventForm.vue";

export default defineComponent({
    name: "EventAddPage",
    components: {EventForm}
})
</script>


<style scoped>
.page-heading {
    border-bottom: 1px solid #e2e6ea;
    padding-bottom: 1rem;
}

.page-eyebrow {
    color: #426cc6;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 0.35rem;
}
</style>
